import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import { Page } from '@/core/architecture'

import { ConsoleItemCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleItemCreate Page
 * Implemented as a practical sample.
 */
export const ConsoleItemCreate: Page = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <Component />
    </DndProvider>
  )
}

const Component: Page = () => {
  const { state, actions } = useViewModel()
  return <ConsoleItemCreateTemplate state={state} {...actions} />
}
